import React , { useContext } from 'react';
import '../styles/ExploreSection.css'; 
import { LanguageContext } from "../LanguageContext"; // Import the context

const ExploreCard = ({ icon, title, description }) => {
    const { language } = useContext(LanguageContext); // Use the context
  
  return (
    <div className={`explore-card ${language === "ar" ? "rtl" : ""}`}>
      <div className="icon"><img src={icon}/></div>
      <div className="text">
      <h3 className="card-title" dir={language === "ar" ? "rtl" : "ltr"}>{title}</h3>
      <p dir={language === "ar" ? "rtl" : "ltr"}>{description}</p>
      </div>
    </div>
  );
};

export default ExploreCard;
